import { useParams } from "react-router-dom";
import "../../i18n/i18n";
import { Spacer, ButtonDS, triggerToast, InputDS } from "@qivia/ui";
import { useTranslation } from "react-i18next";
import {
  vehiclesSlice,
  selectFetchVehicleSivDataStatus,
  fetchVehicleSivDataAsync,
} from "./vehiclesSlice";
import { useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import styled from "styled-components";
import { validateUUID } from "@qivia/ui/src/format";

export const FetchVehicleSivData = () => {
  const { t } = useTranslation();
  const params = useParams();
  const dispatch = useAppDispatch();

  const [displayError, setDisplayError] = useState<boolean>(false);
  const [vehicleUuid, setVehicleUuid] = useState<string>("");
  const fetchVehicleSivDataStatus = useAppSelector(
    selectFetchVehicleSivDataStatus,
  );

  const isValidSubmission = useMemo(
    () => vehicleUuid !== "" && validateUUID(vehicleUuid),
    [vehicleUuid],
  );

  const clickToSubmit = () => {
    if (!isValidSubmission) {
      setDisplayError(true);
    } else {
      setDisplayError(false);
      void dispatch(fetchVehicleSivDataAsync({ vehicleUuid }));
      resetValues();
    }
  };

  const resetValues = () => {
    setVehicleUuid("");
  };

  useEffect(() => {
    if (fetchVehicleSivDataStatus === "success") {
      triggerToast(t("vehicles.fetchVehicleSivData.success") || "", "valid");
    } else if (fetchVehicleSivDataStatus === "failed") {
      triggerToast(t("vehicles.fetchVehicleSivData.failure") || "", "error");
    }
    void dispatch(vehiclesSlice.actions.resetFetchVehicleSivDataStatus());
  }, [dispatch, fetchVehicleSivDataStatus, t]);

  if (params.tab !== "fetchVehicleSivData") {
    return;
  }

  return (
    <StyledContainer>
      <InputDS
        label={t("vehicles.fetchVehicleSivData.input.label")}
        value={vehicleUuid}
        onChange={(e) => setVehicleUuid(e.target.value)}
        error={
          displayError
            ? t("vehicles.fetchVehicleSivData.input.error")
            : undefined
        }
      />
      <Spacer y={2} />
      <ButtonDS
        format="hug"
        buttonType="primary"
        text={t("vehicles.fetchVehicleSivData.button")}
        onClick={clickToSubmit}
        disabled={!isValidSubmission}
      />
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
